import { DrawerProps } from '@mui/material';
import { PropsWithChildren } from 'react';

import { ModalSize } from '../Modal.constants';

import {
  BottomSheetModalContainer,
  BottomSheetModalDrawer,
} from './BottomSheetModal.styled';

type BottomSheetDrawerProps = PropsWithChildren<{
  modalProps?: DrawerProps;
  size?: ModalSize;
  onClose?: () => void;
}>;

export function BottomSheetDrawer({
  modalProps,
  children,
  onClose,
}: Readonly<BottomSheetDrawerProps>) {
  return (
    <BottomSheetModalDrawer
      {...modalProps}
      open
      anchor="bottom"
      hideBackdrop={false}
      onClose={onClose}
    >
      <BottomSheetModalContainer>{children}</BottomSheetModalContainer>
    </BottomSheetModalDrawer>
  );
}
